/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_TitleInputs */

const en_bot_title = /** @type {(inputs: Bot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BystepBot: who we are and how to control it`)
};

const id_bot_title = /** @type {(inputs: Bot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BystepBot: siapa kami dan cara mengaturnya`)
};

/**
* | output |
* | --- |
* | "BystepBot: who we are and how to control it" |
*
* @param {Bot_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_title = /** @type {((inputs?: Bot_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_title(inputs)
	return en_bot_title(inputs)
});